import iconAudioTones from '@/assets/bcIcon/bcAudioTones.png'
import iconBattery from '@/assets/bcIcon/bcBattery.png'
import iconBluetooth from '@/assets/bcIcon/bcBluetooth.png'
import iconCall from '@/assets/bcIcon/bcCall.png'
import iconCategory1 from '@/assets/bcIcon/bcCategory1.png'
import iconCategory2 from '@/assets/bcIcon/bcCategory2.png'
import iconCategory3 from '@/assets/bcIcon/bcCategory3.png'
import iconContacts from '@/assets/bcIcon/bcContacts.png'
import iconDisplay from '@/assets/bcIcon/bcDisplay.png'
import iconMessage from '@/assets/bcIcon/bcMessage.png'
import iconScan from '@/assets/bcIcon/bcScan.png'
import iconSettings from '@/assets/bcIcon/bcSetting.png'
import iconUtility from '@/assets/bcIcon/bcUtility.png'
import { FEATURE_JKC_BLUETOOTH_DEVICE_INTEGRATION } from '@/components/feature_toggles/feature_toggle'

export const MENU_TREE = Object.freeze([
    {
        label: 'オプション機能',
        name: 'OptionalFeatures',
        children: [
            { label: '表示', name: 'Display' },
            { label: '電源オン/モード', name: 'Power-on_Mode' },
            { label: 'トーン/音声/音量', name: 'Tone_Audio_AudioVolume' },
            { label: 'GPS', name: 'GPS' },
            { label: 'データ保持', name: 'DataHold' },
            { label: 'Bluetooth', name: 'Bluetooth' },
            { label: 'VOX/外部接続', name: 'VOX_ExternalDevice' },
            { label: '電池', name: 'Battery' },
            { label: 'キー操作', name: 'KeyFunction' },
            { label: 'パスワード', name: 'Password' },
        ],
    },
    {
        label: 'キー割当て',
        name: 'KeyAssignment',
        children: [
            { label: '一般', name: 'General' },
            { label: 'サイド', name: 'SideKey' },
            { label: 'フロント', name: 'Front' },
            { label: 'マイク・キー', name: 'MicKey' },
            { label: 'メニュー', name: 'Menu' },
            { label: '拡張メニュー', name: 'ExtendedMenu' },
            { label: 'スーパー・ロック', name: 'SuperLock' },
            ...(FEATURE_JKC_BLUETOOTH_DEVICE_INTEGRATION
                ? [{ label: 'Bluetooth機器', name: 'BLEKey' }]
                : []),
        ],
    },
    {
        label: 'スキャン情報',
        name: 'ScanInformation',
        children: [{ label: '一般', name: 'General' }],
    },
    {
        label: '選択呼出',
        name: 'SelCall',
        children: [
            { label: '基本', name: 'General' },
            { label: '定型ステータス・リスト', name: 'StatusList' },
            { label: 'メッセージ・リスト', name: 'MessageList' },
        ],
    },
    {
        label: 'エマージェンシー情報',
        name: 'EmergencyInformation',
        children: [{ label: 'エマージェンシー', name: 'Emergency' }],
    },
    {
        label: 'ネットワーク',
        name: 'Network',
        children: [
            { label: '回線設定', name: 'Configuration' },
            { label: 'トーン', name: 'Tone' },
            { label: 'LTE', name: 'LTE' },
            { label: 'Wi-Fi 無線設定', name: 'Wi-Fi' },
            { label: 'Wi-Fi 設定管理リスト', name: 'Wi-FiManagementList' },
        ],
    },
])

// 第一階層メニュー
export const FIRST_LEVEL_MENU = Object.freeze(
    MENU_TREE.map((item) => ({ label: item.label, name: item.name })),
)

// 第二階層メニュー
export const SECOND_LEVEL_MENU = Object.freeze(
    MENU_TREE.reduce((acc, item) => {
        acc[item.name] = item.children.map((child) => ({ label: child.label, name: child.name }))
        return acc
    }, {}),
)

// 第三階層項目
// TODO: IP無線機画面仕様書/設定項目一覧/機能名と照らし合わせて追加
export const THIRD_LEVEL_MENU = Object.freeze({
    OptionalFeatures: {
        Display: [
            {
                label: '',
                name: '',
                item: [
                    { label: 'グループの遷移方法', name: 'Rollover_EndStop' },
                    { label: 'バックライト', name: 'Backlight' },
                    { label: 'バックライト点灯時間', name: 'BacklightTimer', unit: '秒' },
                    { label: 'モード・リセット・タイマー', name: 'ModeResetTimer', specialCase: true },
                    {
                        label: '',
                        name: 'ModeResetTimerValue',
                        unit: '秒',
                        visible: { name: 'ModeResetTimer', value: '' },
                    },
                    { label: '縦倍角メニュー表示', name: 'DoubleHeightMenuDisplay' },
                ],
            },
            {
                label: 'LED',
                name: 'LEDs',
                item: [
                    { label: '受信時 LED 点灯', name: 'BusyLED' },
                    { label: '送信時 LED 点灯', name: 'TransmitLED' },
                ],
            },
        ],
        'Power-on_Mode': [
            {
                label: '電源オン',
                name: 'Power-on',
                item: [
                    { label: '起動画面', name: 'CustomStart-upScreen' },
                    {
                        label: 'ビットマップファイル',
                        name: 'BitmapFile',
                        visible: { name: 'CustomStart-upScreen', value: 'Enable' },
                        specialCase: true,
                    },
                    { label: '起動メッセージ', name: 'MessageType', specialCase: true },
                    { label: 'テキスト', name: 'Text', visible: { name: 'MessageType', value: '' } },
                    { label: 'グループタイプ', name: 'GroupType' },
                    { label: '電源オン時の LED 色', name: 'Power-onLEDColor' },
                    { label: '電池情報', name: 'BatteryInfo' },
                ],
            },
            {
                label: 'モード',
                name: 'Mode',
                item: [
                    { label: '自己診断', name: 'SelfTest' },
                    { label: 'WPS', name: 'WPS' },
                ],
            },
        ],
        Tone_Audio_AudioVolume: [
            {
                label: 'トーン音量',
                name: 'VolumeLevel',
                item: [
                    { label: 'トーン音量オフセット値', name: 'ToneVolumeOffset' },
                    { label: '電源オン時のトーン', name: 'Power-onTone' },
                    { label: '制御トーン', name: 'ControlTone' },
                    { label: '警告トーン', name: 'WarningTone' },
                    { label: '着信トーン', name: 'AlertTone' },
                    { label: 'サイドトーン', name: 'SideTone' },
                    { label: 'エマージェンシー・トーン', name: 'LocatorTone' },
                ],
            },
            {
                label: '通話トーン',
                name: 'ProceedTone',
                item: [
                    { label: '終話トーン', name: 'PTTReleaseTone' },
                    { label: '通話開始トーン', name: 'PTTProceedTone' },
                ],
            },
            {
                label: '録音',
                name: 'Recording',
                item: [{ label: '再生終了トーン', name: 'PlaybackEndTone' }],
            },
            {
                label: '音声アナウンス',
                name: 'VoiceAnnouncement',
                item: [
                    { label: 'グループ', name: 'Group' },
                    { label: '機能', name: 'Function' },
                ],
            },
            {
                label: 'エコーモード',
                name: 'EchoMode',
                item: [
                    { label: 'エコーモード', name: 'EchoModeFunction' },
                    { label: 'エコーモード音量調整', name: 'EchoModeVolume' },
                ],
            },
            {
                label: 'オーディオ音量',
                name: 'AudioVolume',
                item: [
                    { label: '最大音量', name: 'Maximum' },
                    { label: '最小音量', name: 'Minimum' },
                ],
            },
            {
                label: 'バイブレーター',
                name: 'Vibrator',
                item: [
                    { label: 'バイブレーター', name: 'VibratorFunction' },
                    { label: '着信トーンなし', name: 'WithoutAlertTone' },
                ],
            },
            {
                label: 'エコーキャンセラ',
                name: 'EchoCanceller',
                item: [{ label: 'エコーキャンセラ', name: 'EchoCancellerFunction' }],
            },
        ],
        GPS: [
            {
                label: '',
                name: '',
                item: [
                    { label: 'GPS レポートの間隔', name: 'GPSReportIntervalTime', unit: '秒'},
                ],
            },
        ],
        DataHold: [
            {
                label: '',
                name: '',
                item: [
                    { label: '履歴表示', name: 'MessageDisplay' },
                    { label: '通話言語', name: 'Language' },
                ],
            },
        ],
        Bluetooth: [
            {
                label: '有効・無効',
                name: 'PresetActivation',
                item: [{ label: 'Bluetooth', name: 'BluetoothFunction' }],
            },
        ],
        VOX_ExternalDevice: [
            {
                label: 'VOX',
                name: 'VOX',
                item: [
                    { label: 'VOX', name: 'VOXFunction' },
                    { label: 'キャンセル動作', name: 'CancelByPTT' },
                    { label: 'VOX開始通話トーン', name: 'VOXProceedTone' },
                    { label: '受信中の送信禁止', name: 'TransmitInhibitWhileReceiving' },
                    { label: 'マイク感度', name: 'VOXGainLevel' },
                    { label: '終話遅延時間', name: 'VOXDelayTime', unit: '秒' },
                    { label: 'イヤホン・モード', name: 'EarphoneMode' },
                ],
            },
            {
                label: '外部スピーカー',
                name: 'ExternalSpeaker',
                item: [{ label: '外部スピーカーの設定', name: 'ExternalSpeakerFunction' }],
            },
        ],
        Battery: [
            {
                label: '電池残量表示',
                name: 'BatteryIndicator',
                item: [
                    { label: 'LCD', name: 'LCD' },
                    { label: 'LED', name: 'LED' },
                ],
            },
            {
                label: '電池残量警告',
                name: 'BatteryWarning',
                item: [{ label: 'トーン', name: 'Tone' }],
                visible: [
                    { parentName: 'BatteryIndicator', name: 'LCD', value: 'Enable' },
                    { parentName: 'BatteryIndicator', name: 'LED', value: 'Enable' },
                ],
            },
        ],
        KeyFunction: [
            {
                label: 'PTT ホールド',
                name: 'PTTHold',
                item: [{ label: 'PTT ホールド', name: 'PTTHoldFunction', value: 'Disable' }],
            },
            {
                label: 'セカンド PTT グループ',
                name: 'SecondPTTGroup',
                item: [
                    {
                        label: 'セカンド PTT 送信開始時間',
                        name: 'SecondPTTTransmissionStartTime',
                        specialCase: true,
                    },
                    { label: 'セカンド・グループ表示中のPTT動作', name: 'PTTActionOnSecondGroup' },
                    { label: 'セカンド PTT ビープ音', name: 'SecondPTTBeep' },
                ],
            },
            {
                label: 'キー制御',
                name: 'Control',
                item: [
                    { label: 'スーパー・ロック', name: 'SuperLock' },
                    { label: '高速スクロール', name: 'QuickScroll' },
                ],
            },
        ],
        Password: [
            {
                label: '',
                name: '',
                item: [
                    { label: '無線機パスワード', name: 'TransceiverPassword' },
                    { label: '拡張メニュー・パスワード', name: 'ExtendedMenuPassword' },
                ],
            },
        ],
    },
    KeyAssignment: {
        General: [
            {
                label: 'エマジェンシー・キー割当て',
                name: 'Emergency',
                item: [
                    { label: 'サイド 2 キーへ割当て', name: 'AUX' },
                    { label: 'REM キーへ割当て', name: 'REM' },
                    ...(FEATURE_JKC_BLUETOOTH_DEVICE_INTEGRATION
                        ? [
                            { label: 'Bluetooth機器のボタンへ割当て', name: 'BLE' },
                            {
                                label: '割当てボタン',
                                name: 'BLEButton',
                                visible: { name: 'BLE', value: 'Enable' },
                            },
                        ]
                        : []),
                ],
            },
        ],
        Front: [
            {
                label: 'アップ',
                name: 'Up',
                item: [
                    { label: 'ファンクション', name: 'Function' }, // 設定値表示処理でPress/Releaseを判別する
                    { label: 'ホールド・ファンクション', name: 'HoldFunction' },
                ],
            },
            {
                label: 'ダウン',
                name: 'Down',
                item: [
                    { label: 'ファンクション', name: 'Function' }, // 設定値表示処理でPress/Releaseを判別する
                    { label: 'ホールド・ファンクション', name: 'HoldFunction' },
                ],
            },
            {
                label: '決定',
                name: 'Enter',
                item: [
                    { label: 'ファンクション', name: 'Function' }, // 設定値表示処理でPress/Releaseを判別する
                    { label: 'ホールド・ファンクション', name: 'HoldFunction' },
                ],
            },
            {
                label: '戻る',
                name: 'Back',
                item: [{ label: 'ファンクション', name: 'Function' }], // 設定値表示処理でPress/Releaseを判別する
            },
        ],
        SideKey: [
            {
                label: 'サイド 1',
                name: 'Side1',
                item: [
                    { label: 'ファンクション', name: 'Function' }, // 設定値表示処理でPress/Releaseを判別する
                    { label: 'ホールド・ファンクション', name: 'HoldFunction' },
                ],
            },
            {
                label: 'サイド 2',
                name: 'Side2',
                item: [
                    { label: 'ファンクション', name: 'Function' }, // 設定値表示処理でPress/Releaseを判別する
                    { label: 'ホールド・ファンクション', name: 'HoldFunction' },
                ],
            },
        ],
        MicKey: [
            {
                label: 'REM',
                name: 'REM',
                item: [
                    { label: 'ファンクション', name: 'Function' }, // 設定値表示処理でPress/Releaseを判別する
                    { label: 'ホールド・ファンクション', name: 'HoldFunction' },
                    { label: 'REM キーと PTT スイッチを入替え', name: 'SwapFunctionsREMandPTT' },
                ],
            },
        ],
        Menu: [
            {
                label: '',
                name: '',
                item: [],
            },
        ],
        ExtendedMenu: [
            {
                label: '',
                name: '',
                item: [],
            },
        ],
        SuperLock: [
            {
                label: 'ロックするキーリスト',
                name: 'keyList',
                item: [],
            },
        ],
        BLEKey: FEATURE_JKC_BLUETOOTH_DEVICE_INTEGRATION
            ? [
                {
                    label: 'ボタン 2',
                    name: 'Button2',
                    item: [
                        { label: 'ファンクション', name: 'Function' },
                        { label: 'ホールド・ファンクション', name: 'HoldFunction' },
                    ],
                },
                {
                    label: 'ボタン 3',
                    name: 'Button3',
                    item: [
                        { label: 'ファンクション', name: 'Function' },
                        { label: 'ホールド・ファンクション', name: 'HoldFunction' },
                    ],
                },
                {
                    label: 'ボタン 4',
                    name: 'Button4',
                    item: [
                        { label: 'ファンクション', name: 'Function' },
                        { label: 'ホールド・ファンクション', name: 'HoldFunction' },
                    ],
                },
                {
                    label: 'ボタン 5',
                    name: 'Button5',
                    item: [
                        { label: 'ファンクション', name: 'Function' },
                        { label: 'ホールド・ファンクション', name: 'HoldFunction' },
                    ],
                },
            ]
            : [],
    },
    ScanInformation: {
        General: [
            {
                label: 'オプション',
                name: 'Option',
                item: [
                    { label: '電源オン時のスキャン', name: 'Power-onScan' },
                    { label: 'スキャン時の送信グループ', name: 'SelectScanGroup' },
                ],
            },
        ],
    },
    SelCall: {
        General: [
            {
                label: '',
                name: '',
                item: [
                    { label: 'グループ呼出表示', name: 'GroupCallDisplayType' },
                    { label: '着信時動作の制限（グループ呼出）', name: 'CallAlertInhibit' },
                    { label: '再受信時の着信トーン制限', name: 'AlertToneRestrictionFrom2ndCall' },
                    { label: 'ジッターバッファー', name: 'JitterBuffer' },
                ],
            },
            {
                label: '着信トーン/LED',
                name: 'AlertTone_LED',
                item: [
                    { label: '個別呼出着信トーン', name: 'IndividualCallAlertTone' },
                    { label: '個別呼出着信 LED', name: 'IndividualCallLED' },
                    { label: 'グループ呼出着信トーン', name: 'GroupCallAlertTone' },
                    { label: 'グループ呼出着信 LED', name: 'GroupCallLED' },
                    { label: 'メッセージ着信トーン', name: 'MessageAlertTone' },
                    { label: 'エマージェンシー着信トーン（開始/終了）', name: 'EmergencyAlertTone' },
                ],
            },
            {
                label: '受信モード解除',
                name: 'AutoReset',
                item: [
                    { label: '受信モード解除時間', name: 'AutoResetTimer', specialCase: true },
                    {
                        label: '',
                        name: 'AutoResetTimerValue',
                        visible: { name: 'AutoResetTimer', value: '' },
                        unit: '秒',
                    },
                    { label: 'LCD', name: 'LCD' },
                    { label: 'LED', name: 'LED' },
                    { label: '着信トーン', name: 'AlertTone' },
                ],
            },
        ],
        StatusList: [
            {
                label: '',
                name: '',
            },
        ],
        MessageList: [
            {
                label: '',
                name: '',
            },
        ],
    },
    EmergencyInformation: {
        Emergency: [
            {
                label: '基本',
                name: '',
                item: [
                    { label: 'エマージェンシーの種類', name: 'EmergencyModeType' },
                    { label: 'エマージェンシー周期', name: 'EmergencyCycle', specialCase: true },
                    {
                        label: '',
                        name: 'EmergencyCycleValue',
                        unit: '回',
                        visible: { name: 'EmergencyCycle', value: '' },
                    },
                    {
                        label: 'トーン送出時間',
                        name: 'DurationLocatorTone',
                        unit: '秒',
                        visible: { name: 'EmergencyModeType', value: 'Audible' },
                    },
                    { label: '自動送信時間', name: 'TransmitDuration', unit: '秒' },
                    { label: 'エマージェンシー時の表示', name: 'EmergencyDisplay', specialCase: true },
                    { label: '文字列', name: 'EmergencyText', visible: { name: 'EmergencyDisplay', value: 'Text' } },
                    { label: 'エマージェンシー・モード解除要求', name: 'EmergencyStopRequest' },
                ],
            },
            {
                label: 'トーン/LED',
                name: '',
                item: [
                    { label: 'LED', name: 'EmergencyLED' },
                    { label: 'バックグラウンド・トーン', name: 'BackgroundToneTransmission' },
                ],
            },
            {
                label: '定時確認（ローン・ワーカー）',
                name: 'LoneWorker',
                item: [
                    { label: '定時確認（ローン・ワーカー）タイプ', name: 'LoneWorkerType' },
                    { label: 'トーン送出の待機時間', name: 'LoneWorkerInterval', unit: '分' },
                    {
                        label: 'トーン送出時間',
                        name: 'DurationLoneWorkerTone',
                        specialCase: true,
                    },
                    {
                        label: '',
                        name: 'DurationLoneWorkerToneValue',
                        unit: '秒',
                        visible: { name: 'DurationLoneWorkerTone', value: '' },
                    },
                ],
            },
            {
                label: 'エマージェンシー検知',
                name: 'EmergencyDetection',
                item: [
                    { label: '転倒検知', name: 'Man-downDetection' },
                    {
                        label: '転倒検知及び静止検知',
                        name: 'Man-downWithStationary',
                        visible: { name: 'Man-downDetection', value: 'Enable' },
                    },
                    {
                        label: '転倒検知の角度',
                        name: 'Man-downAngle',
                        unit: '度',
                        visible: { name: 'Man-downDetection', value: 'Enable' },
                    },
                    {
                        label: 'エマージェンシー遅延時間',
                        name: 'Man-downDelayTime',
                        visible: { name: 'Man-downDetection', value: 'Enable' },
                        specialCase: true,
                    },
                    {
                        label: '',
                        name: 'Man-downDelayTimeValue',
                        unit: '秒',
                        visible: { name: 'Man-downDelayTime', value: '' },
                    },
                    {
                        label: '警告トーン出力時間',
                        name: 'Man-downPre-alert',
                        visible: { name: 'Man-downDetection', value: 'Enable' },
                        specialCase: true,
                    },
                    {
                        label: '',
                        name: 'Man-downPre-alertValue',
                        unit: '秒',
                        visible: { name: 'Man-downPre-alert', value: '' },
                    },
                    { label: '静止検知', name: 'StationaryDetection' },
                    {
                        label: 'エマージェンシー遅延時間',
                        name: 'StationaryDelayTime',
                        visible: { name: 'StationaryDetection', value: 'Enable' },
                        specialCase: true,
                    },
                    {
                        label: '',
                        name: 'StationaryDelayTimeValue',
                        unit: '秒',
                        visible: { name: 'StationaryDelayTime', value: '' },
                    },
                    {
                        label: '警告トーン出力時間',
                        name: 'StationaryPre-alert',
                        visible: { name: 'StationaryDetection', value: 'Enable' },
                        specialCase: true,
                    },
                    {
                        label: '',
                        name: 'StationaryPre-alertValue',
                        unit: '秒',
                        visible: { name: 'StationaryPre-alert', value: '' },
                    },
                    { label: '動き検知', name: 'MotionDetection' },
                    {
                        label: 'エマージェンシー遅延時間',
                        name: 'MotionDelayTime',
                        visible: { name: 'MotionDetection', value: 'Enable' },
                        specialCase: true,
                    },
                    {
                        label: '',
                        name: 'MotionDelayTimeValue',
                        unit: '秒',
                        visible: { name: 'MotionDelayTime', value: '' },
                    },
                    {
                        label: '警告トーン出力時間',
                        name: 'MotionPre-alert',
                        visible: { name: 'MotionDetection', value: 'Enable' },
                        specialCase: true,
                    },
                    {
                        label: '',
                        name: 'MotionPre-alertValue',
                        unit: '秒',
                        visible: { name: 'MotionPre-alert', value: '' },
                    },
                ],
            },
        ],
    },
    Network: {
        Configuration: [
            {
                label: '閾値設定',
                name: 'Threshold',
                item: [
                    {
                        label: '切替閾値',
                        item: [
                            { label: 'LTE', name: 'HandoverLTE' },
                            { label: 'Wi-Fi', name: 'HandoverWi-Fi' },
                        ],
                    },
                    {
                        label: '復帰閾値',
                        item: [
                            { label: 'LTE', name: 'ReconnectionLTE' },
                            { label: 'Wi-Fi', name: 'ReconnectionWi-Fi' },
                        ],
                    },
                ],
            },
        ],
        Tone: [
            {
                label: '',
                name: '',
                item: [
                    { label: '接続完了トーン', name: 'ConnectedTone' },
                    { label: '圏外警告トーン', name: 'OutOfRangeWarningTone' },
                ],
            },
        ],
        LTE: [
            {
                label: '',
                name: '',
                item: [
                    { label: 'キャリア表示', name: 'MobileCarrierDisplay' },
                    { label: '緊急速報', name: 'CriticalAlerts' },
                ],
            },
        ],
        'Wi-Fi': [
            {
                label: '',
                name: '',
                item: [
                    {
                        label: 'Wi-Fi スキャンチャネル',
                        name: 'ScanBand',
                        item: [
                            { name: 'ScanAll' },
                            { prop: 'BAND_2G', label: '2.4 GHz', name: '2G' },
                            { prop: 'W52', label: 'W52', name: 'W52' },
                            { prop: 'W53', label: 'W53', name: 'W53' },
                            { prop: 'W56', label: 'W56', name: 'W56' },
                        ],
                    },
                    {
                        label: 'Wi-Fi 送信出力',
                        name: 'Wi-FiTxPowerSetting',
                        item: [{ name: 'TxPowerValue' }],
                    },
                    {
                        label: 'Wi-Fi ローミングレベル',
                        name: 'Wi-FiRoamingSetting',
                        item: [{ name: 'RoamingLevel' }],
                    },
                ],
            },
        ],
        'Wi-FiManagementList': [
            {
                label: 'SSID',
                name: 'SSID',
                item: [
                    { label: 'セキュリティ設定', name: 'SecurityType' },
                    { label: 'パスワード', name: 'Wi-FiPassword' },
                    { label: '自動接続設定', name: 'AutoConnectSetting' },
                    { label: 'IP割り当て設定', name: 'IPAssignment' },
                    { label: 'IPアドレス', name: 'IPAddress' },
                    { label: 'サブネットマスク', name: 'SubnetMask' },
                    { label: 'デフォルトゲートウェイ', name: 'DefaultGateway' },
                    { label: 'プライマリDNSサーバ', name: 'PrimaryDNSServer' },
                    { label: 'セカンダリDNSサーバ', name: 'SecondaryDNSServer' }
                ],
            },
        ],
    },
})

export const BC = Object.freeze({
    COMMON: {
        TOGGLE: {
            ENABLE: 'Enable',
            DISABLE: 'Disable',
        },
        LED_COLOR: {
            YELLOW: 'Yellow',
            PURPLE: 'Purple',
            BLUE: 'Blue',
            LIGHT_BLUE: 'LightBlue',
            RED: 'Red',
            GREEN: 'Green',
            WHITE: 'White',
        },
        TONE: {
            DISABLE: 'Disable',
            FIXED: 'Fixed',
            CURRENT: 'Current',
            SELECTABLE: 'Selectable',
            SELECT: ['固定音量', 'ボリューム連動', '固定音量連動'],
        },
    },
    OPTIONAL_FEATURES: {
        DISPLAY: {
            ROLLOVER_END_STOP: { ROLLOVER: 'Rollover', END_STOP: 'EndStop' },
            BACKLIGHT: {
                DISABLE: 'Disable',
                KEY_OPERATION: 'KeyOperation',
                KEY_AND_RECEIVE: 'Key&Receive',
            },
            BACKLIGHT_TIMER: [5, 10, 15, 30, 60],
            MODE_RESET_TIMER_VALUE: {
                MIN: 1,
                MAX: 300,
            },
        },
        POWER_ON_MODE: {
            POWER_ON: {
                MESSAGE_TYPE: { DISABLE: 'Disable', TEXT: 'Text', UNIT_ID: 'UnitID' },
                GROUP_TYPE: { LAST_USED: 'LastUsed', PRESET: 'Preset' },
                BATTERY_INFO: {
                    DISABLE: 'Disable',
                    CHARGE: 'Charge',
                    VOLTAGE: 'Voltage',
                },
            },
        },
        TONE_AUDIO_AUDIO_VOLUME: {
            VOLUME_LEVEL: {
                TONE_VOLUME_OFFSET: {
                    MIN: -5,
                    MAX: 5,
                },
                TONE_VOLUME: {
                    MIN: 1,
                    MAX: 31,
                },
            },
            ECHO_MODE: {
                ECHO_MODE_VOLUME: {
                    MIN: 1,
                    MAX: 10,
                },
            },
            AUDIO_VOLUME: {
                MIN: 0,
                MAX: 31,
            },
            RX_AUDIO_RESPONSE: {
                AUTO_GAIN_CONTROL: { DISABLE: 'Disable', LOW: 'low', HIGH: 'High' },
            },
        },
        GPS: {
            GPS_REPORT_INTERVAL_TIME: [5, 30, 60, 300],
        },
        DATA_HOLD: {
            MESSAGE_DISPLAY: { DESCENDING: 'Descending', ASCENDING: 'Ascending' },
            LANGUAGE: {
                JAPANESE: 'Japanese',
                ITALIAN: 'Italian',
                INDONESIAN: 'Indonesian',
                UKRAINIAN: 'Ukrainian',
                DUTCH: 'Dutch',
                GREEK: 'Greek',
                SPANISH: 'Spanish',
                THAI: 'Thai',
                CZECH: 'Czech',
                GERMAN: 'German',
                TURKISH: 'Turkish',
                HUNGARIAN: 'Hungarian',
                HINDI: 'Hindi',
                FINNISH: 'Finnish',
                FRENCH: 'French',
                BULGARIAN: 'Bulgarian',
                VIETNAMESE: 'Vietnamese',
                POLISH: 'Polish',
                PORTUGUESE_BRAZIL: 'PortugueseBrazil',
                PORTUGUESE_PORTUGAL: 'PortuguesePortugal',
                ROMANIAN: 'Romanian',
                RUSSIAN: 'Russian',
                ENGLISH: 'English',
                KOREAN: 'Korean',
                CANTONESE: 'Cantonese',
                SIMPLIFIED_CHINESE: 'SimplifiedChinese',
                TRADITIONAL_CHINESE: 'TraditionalChinese',
                SELECT: [
                    'Japanese',
                    'Italian',
                    'Indonesian',
                    'Ukrainian',
                    'Dutch',
                    'Greek',
                    'Spanish',
                    'Thai',
                    'Czech',
                    'German',
                    'Turkish',
                    'Hungarian',
                    'Hindi',
                    'Finnish',
                    'French',
                    'Bulgarian',
                    'Vietnamese',
                    'Polish',
                    'PortugueseBrazil',
                    'PortuguesePortugal',
                    'Romanian',
                    'Russian',
                    'English',
                    'Korean',
                    'Cantonese',
                    'SimplifiedChinese',
                    'TraditionalChinese',
                ],
            },
        },
        BLUETOOTH: {
            BLUETOOTH: {
                BLUETOOTH_HEADSET_CONNECTION_TYPE: {
                    HEADSET1: 'Headset1',
                    HEADSET2: 'Headset2',
                },
            },
        },
        VOX_EXTERNAL_DEVICE: {
            VOX: {
                VOX_GAIN_LEVEL: {
                    MIN: 1,
                    MAX: 10,
                },
                VOX_DELAY_TIME: [0.1, 0.3, 0.5, 1.0, 1.5, 2.0, 3.0],
            },
        },
        KEY_FUNCTION: {
            PTT_HOLD: {
                PTT_HOLD_FUNCTION: {
                    DISABLE: 'Disable',
                    ENABLE: 'Enable',
                    DOUBLE_CLICK: 'DoubleClick',
                },
            },
            SECOND_PTT_GROUP: {
                SECOND_PTT_TRANSMISSION_START_TIME: {
                    IMMEDIATE: 'Immediate',
                    ONE_SECOND: '1',
                },
                PTT_ACTION_ON_SECOND_GROUP: {
                    TX_INHIBIT: 'TxInhibit',
                    HOME_GROUP: 'HomeGroup',
                    SECOND_GROUP: 'SecondGroup',
                },
            },
            CONTROL: {
                SUPER_LOCK: {
                    DISABLE: 'Disable',
                    CUSTOM: 'Custom',
                    TX_ALLOWED: 'TxAllowed',
                    GROUP_CHANGE_ALLOWED: 'GroupChangeAllowed',
                },
            },
        },
    },
    EMERGENCY_INFORMATION: {
        EMERGENCY: {
            EMERGENCY_MODE_TYPE: {
                SILENT: 'Silent',
                AUDIBLE: 'Audible',
            },
            EMERGENCY_CYCLE: {
                DISABLE: 'Disable',
                ENABLE: 'Enable',
                INFINITE: 'Infinite',
            },
            EMERGENCY_CYCLE_VALUE: {
                MIN: 1,
                MAX: 200,
            },
            DURATION_LOCATOR_TONE: {
                MIN: 0,
                MAX: 255,
            },
            TRANSMIT_DURATION: {
                MIN: 0,
                MAX: 60,
            },
            EMERGENCY_DISPLAY: {
                SELECTED_GROUP: 'SelectedGroup',
                TEXT: 'Text',
            },
            LONE_WORKER: {
                LONE_WORKER_TYPE: {
                    NORMAL: 'Normal',
                    TX_RX_INHIBIT: 'TxRxInhibit',
                },
                LONE_WORKER_INTERVAL: {
                    MIN: 1,
                    MAX: 180,
                },
                DURATION_LONE_WORKER_TONE_VALUE: {
                    MIN: 1,
                    MAX: 255,
                },
            },
            EMERGENCY_DETECTION: {
                MAN_DOWN_ANGLE: [45, 60, 75],
                MAN_DOWN_DELAY_TIME_VOLUME: {
                    MIN: 1,
                    MAX: 70,
                },
                MAN_DOWN_PRE_ALERT_VALUE: {
                    MIN: 1,
                    MAX: 69,
                },
                STATIONARY_DELAY_TIME_VOLUME: {
                    MIN: 1,
                    MAX: 240,
                },
                STATIONARY_PRE_ALERT_VALUE: {
                    MIN: 1,
                    MAX: 239,
                },
                MOTION_DELAY_TIME_VOLUME: {
                    MIN: 1,
                    MAX: 70,
                },
                MOTION_PRE_ALERT_VALUE: {
                    MIN: 1,
                    MAX: 69,
                },
            },
        },
    },
    SCAN_INFORMATION: {
        GENERAL: {
            OPTION: {
                SELECT_SCAN_GROUP: { SELECTED: 'Selected', SELECTED_TALKBACK: 'Selected+Talkback' },
            },
        },
    },
    NETWORK: {
        CONFIGURATION: {
            THRESHOLD: {
                HANDOVER_LTE: {
                    MIN: -20,
                    MAX: -4,
                },
                HANDOVER_WIFI: {
                    MIN: -130,
                    MAX: -11,
                },
                RECONNECTION_LTE: {
                    MIN: -19,
                    MAX: -3,
                },
                RECONNECTION_WIFI: {
                    MIN: -129,
                    MAX: -10,
                },
            },
        },
        TONE: {
            OUT_OF_RANGE_WARNING_TONE: {
                DISABLE: 'Disable',
                ONE_SHOT: 'OneShot',
                REPEAT: 'Repeat',
            },
        },
        WIFI: {
            SCAN_BANDS: {
                SCAN_ALL: {
                    LABEL: '',
                    ITEMS: ['all'],
                },
                BAND_2G: {
                    LABEL: '2.4 GHz',
                    ITEMS: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13'],
                },
                W52: {
                    LABEL: 'W52',
                    ITEMS: ['36', '40', '44', '48'],
                },
                W53: {
                    LABEL: 'W53',
                    ITEMS: ['52', '56', '60', '64'],
                },
                W56: {
                    LABEL: 'W56',
                    ITEMS: [
                        '100',
                        '104',
                        '108',
                        '112',
                        '116',
                        '120',
                        '124',
                        '128',
                        '132',
                        '136',
                        '140',
                        '144',
                    ],
                },
            },
            WIFI_TX_POWER_SETTING: {
                TX_POWER_VALUE: {
                    MIN: -15,
                    MAX: 0,
                },
            },
            WIFI_ROAMING_SETTING: {
                ROAMING_LEVEL: {
                    MIN: -100,
                    MAX: -70,
                },
            },
        },
        WIFI_MANAGEMENT_LIST: {
            SECURITY_TYPE: { WPA3: 'WPA3', WPA2: 'WPA2', ENHANCED_OPEN: 'EnhancedOpen' },
            IP_ASSIGNMENT: { DHCP: 'DHCP', MANUAL: 'Manual' },
        },
    },
    SEL_CALL: {
        GENERAL: {
            GROUP_CALL_DISPLAY_TYPE: {
                GROUP_ID: 'GroupID',
                CALLING_TRANSCEIVER_ID: 'CallingTransceiverID',
                CALLING_TRANSCEIVER_ID_GROUP_ID: 'CallingTransceiverID_GroupID',
            },
            JITTER_BUFFER: {
                AUTO: 'Auto',
                VALUE: ['40', '80', '120', '160', '200', '240', '280', '320', '360', '400', '440', '480'],
            },
            AUTO_RESET: {
                AUTO_RESET_TIMER_VALUE: {
                    MIN: 0,
                    MAX: 300,
                },
            },
        },
    },
})

export const BC_TRANS_JP = Object.freeze({
    COMMON: {
        TOGGLE: {
            ENABLE: '有効',
            DISABLE: '無効',
        },
        LED_COLOR: {
            YELLOW: '黄色',
            PURPLE: '紫色',
            BLUE: '青色',
            LIGHT_BLUE: '水色',
            RED: '赤色',
            GREEN: '緑色',
            WHITE: '白色',
        },
        TONE: {
            FIXED: '固定音量',
            CURRENT: 'ボリューム連動',
            SELECTABLE: '固定音量連動',
        },
    },
    OPTIONAL_FEATURES: {
        DISPLAY: {
            ROLLOVER_END_STOP: {
                ROLLOVER: '循環',
                END_STOP: '終止',
            },
            BACKLIGHT: { KEY_OPERATION: '操作時点灯', KEY_AND_RECEIVE: '操作＆送受信時点灯' },
        },
        POWER_ON_MODE: {
            POWER_ON: {
                MESSAGE_TYPE: { TEXT: '文字列', UNIT_ID: 'ユーザー表示名' },
                GROUP_TYPE: { LAST_USED: 'バックアップ', PRESET: '固定' },
                BATTERY_INFO: {
                    CHARGE: '残容量[%]',
                    VOLTAGE: '電圧[V]',
                },
            },
        },
        TONE_AUDIO_AUDIO_VOLUME: {
            RX_AUDIO_RESPONSE: {
                AUTO_GAIN_CONTROL: { LOW: '弱', HIGH: '強' },
            },
        },
        DATA_HOLD: {
            MESSAGE_DISPLAY: { DESCENDING: '降順', ASCENDING: '昇順' },
            LANGUAGE: {
                JAPANESE: '日本語',
                ITALIAN: 'イタリア語',
                INDONESIAN: 'インドネシア語',
                UKRAINIAN: 'ウクライナ語',
                DUTCH: 'オランダ語',
                GREEK: 'ギリシャ語',
                SPANISH: 'スペイン語',
                THAI: 'タイ語',
                CZECH: 'チェコ語',
                GERMAN: 'ドイツ語',
                TURKISH: 'トルコ語',
                HUNGARIAN: 'ハンガリー語',
                HINDI: 'ヒンディー語',
                FINNISH: 'フィンランド語',
                FRENCH: 'フランス語',
                BULGARIAN: 'ブルガリア語',
                VIETNAMESE: 'ベトナム語',
                POLISH: 'ポーランド語',
                PORTUGUESE_BRAZIL: 'ポルトガル語（ブラジル）',
                PORTUGUESE_PORTUGAL: 'ポルトガル語（ポルトガル）',
                ROMANIAN: 'ルーマニア語',
                RUSSIAN: 'ロシア語',
                ENGLISH: '英語',
                KOREAN: '韓国語',
                CANTONESE: '広東語（香港）',
                SIMPLIFIED_CHINESE: '中国語 - 簡体字',
                TRADITIONAL_CHINESE: '中国語 - 繁体字',
            },
        },
        BLUETOOTH: {
            BLUETOOTH: {
                BLUETOOTH_HEADSET_CONNECTION_TYPE: {
                    HEADSET1: 'ヘッドセット1',
                    HEADSET2: 'ヘッドセット2',
                },
            },
        },
        KEY_FUNCTION: {
            PTT_HOLD: {
                PTT_HOLD_FUNCTION: {
                    DISABLE: '無効',
                    ENABLE: '有効',
                    DOUBLE_CLICK: '2回押し',
                },
            },
            SECOND_PTT_GROUP: {
                SECOND_PTT_TRANSMISSION_START_TIME: {
                    IMMEDIATE: '即時',
                    ONE_SECOND: '1秒',
                },
                PTT_ACTION_ON_SECOND_GROUP: {
                    TX_INHIBIT: '送信禁止',
                    HOME_GROUP: '待ち受けグループ送信',
                    SECOND_GROUP: 'セカンド・グループ送信',
                },
            },
            CONTROL: {
                SUPER_LOCK: {
                    DISABLE: '無効',
                    CUSTOM: 'カスタマイズ(キーメニュー)',
                    TX_ALLOWED: '送信許可',
                    GROUP_CHANGE_ALLOWED: 'グループ変更許可',
                },
            },
        },
    },
    KEY_ASSIGNMENT: {
        GENERAL: {
            EMERGENCY: {
                BLE_BUTTON: {
                    BUTTON2: 'ボタン 2',
                    BUTTON3: 'ボタン 3',
                    BUTTON4: 'ボタン 4',
                    BUTTON5: 'ボタン 5',
                },
            },
        },
    },
    EMERGENCY_INFORMATION: {
        EMERGENCY: {
            EMERGENCY_MODE_TYPE: {
                SILENT: '無音',
                AUDIBLE: '通常',
            },
            EMERGENCY_CYCLE: {
                DISABLE: '無効',
                INFINITE: '無制限',
            },
            EMERGENCY_DISPLAY: {
                SELECTED_GROUP: 'エマージェンシー・グループ',
                TEXT: '文字列',
            },
            LONE_WORKER: {
                LONE_WORKER_TYPE: {
                    NORMAL: '通常',
                    TX_RX_INHIBIT: '無線機の送受信禁止',
                },
            },
        },
    },
    SCAN_INFORMATION: {
        GENERAL: {
            OPTION: {
                SELECT_SCAN_GROUP: { SELECTED: '選択', SELECTED_TALKBACK: '選択＋トークバック' },
            },
        },
    },
    NETWORK: {
        CONFIGURATION: {
            THRESHOLD: {
                HANDOVER_LTE: {
                    OUT_OF_RANGE: '圏外',
                },
                HANDOVER_WIFI: {
                    OUT_OF_RANGE: '圏外',
                },
            },
        },
        TONE: {
            OUT_OF_RANGE_WARNING_TONE: {
                DISABLE: '無効',
                ONE_SHOT: '最初のみ',
                REPEAT: 'リピート',
            },
        },
        WIFI: {
            SCAN_BANDS: {
                SCAN_ALL: {
                    ITEMS: ['全て'],
                },
            },
        },
        WIFI_MANAGEMENT_LIST: {
            IP_ASSIGNMENT: { DHCP: '自動', MANUAL: '手動' },
        },
    },
    SEL_CALL: {
        GENERAL: {
            GROUP_CALL_DISPLAY_TYPE: {
                GROUP_ID: 'グループ表示名',
                CALLING_TRANSCEIVER_ID: '発呼者名',
                CALLING_TRANSCEIVER_ID_GROUP_ID: '発呼者名/グループ表示名',
            },
            JITTER_BUFFER: {
                AUTO: '自動',
            },
        },
    },
})

export const SPECIAL_CASE_VIEW = Object.freeze({
    OPTIONAL_FEATURES: {
        DISPLAY: {
            MODE_RESET_TIMER: { judge: 'Enable', place: 'ModeResetTimerValue' },
        },
        POWER_ON_MODE: {
            POWER_ON: {
                BITMAP_FILE: { judge: 'notNull', value: 'あり' },
                MESSAGE_TYPE: { judge: 'Text', place: 'Text' },
            },
        },
        KEY_FUNCTION: {
            SECOND_PTT_GROUP: {
                SECOND_PTT_TRANSMISSION_START_TIME: {
                    judge: '1',
                    value: 'ONE_SECOND',
                },
            },
        },
    },
    SEL_CALL: {
        GENERAL: {
            AUTO_RESET: {
                AUTO_RESET_TIMER: { judge: 'Enable', place: 'AutoResetTimerValue' },
            },
        },
    },
    EMERGENCY_INFORMATION: {
        EMERGENCY: {
            EMERGENCY_CYCLE: {
                judge: 'Enable',
                place: 'EmergencyCycleValue',
            },
            LONE_WORKER: {
                DURATION_LONE_WORKER_TONE: {
                    judge: 'Enable',
                    place: 'DurationLoneWorkerToneValue',
                },
            },
            EMERGENCY_DETECTION: {
                MAN_DOWN_DELAY_TIME: {
                    judge: 'Enable',
                    place: 'Man-downDelayTimeValue',
                },
                MAN_DOWN_PRE_ALERT: {
                    judge: 'Enable',
                    place: 'Man-downPre-alertValue',
                },
                STATIONARY_DELAY_TIME: {
                    judge: 'Enable',
                    place: 'StationaryDelayTimeValue',
                },
                STATIONARY_PRE_ALERT: {
                    judge: 'Enable',
                    place: 'StationaryPre-alertValue',
                },
                MOTION_DELAY_TIME: {
                    judge: 'Enable',
                    place: 'MotionDelayTimeValue',
                },
                MOTION_PRE_ALERT: {
                    judge: 'Enable',
                    place: 'MotionPre-alertValue',
                },
            },
        },
    },
})

export const FUNCTION_LIST = Object.freeze([
    {
        label: 'なし',
        value: 'None',
        type: {
            menu: false,
            extendedMenu: false,
            key: true,
            superLock: false,
        },
        function: {
            function: true,
            holdFunction: true,
            holdFunctionDefault: 'None',
        },
    },
    {
        label: 'エマージェンシーの検知',
        value: 'ActivityDetection',
        type: {
            menu: true,
            extendedMenu: false,
            key: true,
            superLock: true,
        },
        function: {
            function: true,
            holdFunction: true,
            holdFunctionDefault: 'None',
        },
    },
    {
        label: 'エマージェンシー遅延のリセット',
        value: 'ActivityReset',
        type: {
            menu: false,
            extendedMenu: false,
            key: true,
            superLock: true,
        },
        function: {
            function: true,
            holdFunction: true,
            holdFunctionDefault: 'None',
        },
    },
    {
        label: '全設定初期化',
        value: 'AllReset',
        type: {
            menu: true,
            extendedMenu: true,
            key: false,
            superLock: false,
        },
    },
    {
        label: '自動バックライト',
        value: 'AutoBacklight',
        type: {
            menu: true,
            extendedMenu: true,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'バックライト',
        value: 'Backlight',
        type: {
            menu: false,
            extendedMenu: false,
            key: true,
            superLock: true,
        },
        function: {
            function: true,
            holdFunction: true,
            holdFunctionDefault: 'None',
        },
    },
    {
        label: 'Bluetooth',
        value: 'Bluetooth',
        type: {
            menu: true,
            extendedMenu: true,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'Bluetooth 電池セーブ',
        value: 'BluetoothBatterySaver',
        type: {
            menu: true,
            extendedMenu: true,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'Bluetooth 機器',
        value: 'BluetoothDevice',
        type: {
            menu: true,
            extendedMenu: true,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'Bluetooth 情報',
        value: 'BluetoothInformation',
        type: {
            menu: true,
            extendedMenu: true,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'Bluetooth スピーカー',
        value: 'BluetoothSpeaker',
        type: {
            menu: true,
            extendedMenu: false,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'お気に入り',
        value: 'Bookmark',
        type: {
            menu: true,
            extendedMenu: false,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'キー・ロック',
        value: 'ButtonLock',
        type: {
            menu: false,
            extendedMenu: false,
            key: true,
            superLock: true,
        },
        function: {
            function: true,
            holdFunction: true,
            holdFunctionDefault: 'None',
        },
    },
    {
        label: 'キャリア表示',
        value: 'CarriersDisplay',
        type: {
            menu: true,
            extendedMenu: false,
            key: false,
            superLock: false,
        },
    },
    {
        label: '通信テスト',
        value: 'Connectivitytest',
        type: {
            menu: true,
            extendedMenu: true,
            key: false,
            superLock: false,
        },
    },
    {
        label: '縦倍角メニュー表示',
        value: 'DoubleHeightMenu',
        type: {
            menu: true,
            extendedMenu: true,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'イヤホン・モード',
        value: 'EarphoneMode',
        type: {
            menu: true,
            extendedMenu: true,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'エコーキャンセラ',
        value: 'EchoCanceller',
        type: {
            menu: true,
            extendedMenu: false,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'エコーモード',
        value: 'EchoMode',
        type: {
            menu: true,
            extendedMenu: false,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'エコーモード音量調整',
        value: 'EchoVolumeControl',
        type: {
            menu: true,
            extendedMenu: false,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'エマージェンシー',
        value: 'Emergency',
        type: {
            menu: false,
            extendedMenu: false,
            key: true,
            superLock: true,
        },
        function: {
            function: false,
            holdFunction: false,
            holdFunctionDefault: null,
        },
    },
    {
        label: '外部スピーカー',
        value: 'ExternalSpeaker',
        type: {
            menu: true,
            extendedMenu: false,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'Factory Reset',
        value: 'FactoryReset',
        type: {
            menu: false,
            extendedMenu: true,
            key: false,
            superLock: false,
        },
    },
    {
        label: '固定音量',
        value: 'FixedVolume',
        type: {
            menu: true,
            extendedMenu: true,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'GPS',
        value: 'GPS',
        type: {
            menu: true,
            extendedMenu: false,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'グループ番号ダウン',
        value: 'GroupDown',
        type: {
            menu: false,
            extendedMenu: false,
            key: true,
            superLock: true,
        },
        function: {
            function: true,
            holdFunction: true,
            holdFunctionDefault: 'GroupDown(Continuous)',
        },
    },
    {
        label: 'グループ番号ダウン (連続)',
        value: 'GroupDown(Continuous)',
        type: {
            menu: false,
            extendedMenu: false,
            key: true,
            superLock: false,
        },
        function: {
            function: false,
            holdFunction: false,
            holdFunctionDefault: null,
        },
    },
    {
        label: 'グループ番号アップ',
        value: 'GroupUp',
        type: {
            menu: false,
            extendedMenu: false,
            key: true,
            superLock: true,
        },
        function: {
            function: true,
            holdFunction: true,
            holdFunctionDefault: 'GroupUp(Continuous)',
        },
    },
    {
        label: 'グループ番号アップ (連続)',
        value: 'GroupUp(Continuous)',
        type: {
            menu: false,
            extendedMenu: false,
            key: true,
            superLock: false,
        },
        function: {
            function: false,
            holdFunction: false,
            holdFunctionDefault: null,
        },
    },
    {
        label: 'グループ + メッセージ',
        value: 'Group+Message',
        type: {
            menu: true,
            extendedMenu: false,
            key: true,
            superLock: true,
        },
        function: {
            function: true,
            holdFunction: true,
            holdFunctionDefault: 'Stack',
        },
    },
    {
        label: '個別',
        value: 'Individual',
        type: {
            menu: true,
            extendedMenu: false,
            key: true,
            superLock: true,
        },
        function: {
            function: true,
            holdFunction: true,
            holdFunctionDefault: 'Stack',
        },
    },
    {
        label: '個別 + メッセージ',
        value: 'Individual+Message',
        type: {
            menu: true,
            extendedMenu: false,
            key: true,
            superLock: true,
        },
        function: {
            function: true,
            holdFunction: true,
            holdFunctionDefault: 'Stack',
        },
    },
    {
        label: '電池情報表示',
        value: 'IntelligentBattery',
        type: {
            menu: true,
            extendedMenu: true,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'ジッターバッファー設定',
        value: 'JitterBuffer',
        type: {
            menu: true,
            extendedMenu: true,
            key: false,
            superLock: false,
        },
    },
    {
        label: '定時確認 (ローン・ワーカー)',
        value: 'LoneWorker',
        type: {
            menu: true,
            extendedMenu: false,
            key: true,
            superLock: true,
        },
        function: {
            function: true,
            holdFunction: true,
            holdFunctionDefault: 'None',
        },
    },
    {
        label: 'メンテナンス',
        value: 'Maintenance',
        type: {
            menu: true,
            extendedMenu: true,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'メンバーリスト',
        value: 'MemberList',
        type: {
            menu: true,
            extendedMenu: false,
            key: true,
            superLock: true,
        },
        function: {
            function: true,
            holdFunction: true,
            holdFunctionDefault: 'None',
        },
    },
    {
        label: 'メニュー',
        value: 'Menu',
        type: {
            menu: false,
            extendedMenu: false,
            key: true,
            superLock: true,
        },
        function: {
            function: true,
            holdFunction: true,
            holdFunctionDefault: 'None',
        },
    },
    {
        label: 'テキスト受信時の自動読み上げ',
        value: 'MessageAutoRead',
        type: {
            menu: true,
            extendedMenu: false,
            key: false,
            superLock: false,
        },
    },
    {
        label: '回線設定',
        value: 'NetworkSettings',
        type: {
            menu: true,
            extendedMenu: true,
            key: false,
            superLock: false,
        },
    },
    {
        label: '録音再生(最新)',
        value: 'Playback(NewestRecording)',
        type: {
            menu: false,
            extendedMenu: false,
            key: true,
            superLock: true,
        },
        function: {
            function: true,
            holdFunction: true,
            holdFunctionDefault: 'None',
        },
    },
    {
        label: '電源オン時の LED',
        value: 'Power-onLED',
        type: {
            menu: false,
            extendedMenu: true,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'PTT',
        value: 'PTT',
        type: {
            menu: false,
            extendedMenu: false,
            key: false,
            superLock: true,
        },
    },
    {
        label: 'PTT ホールド',
        value: 'PTTHold',
        type: {
            menu: true,
            extendedMenu: true,
            key: false,
            superLock: false,
        },
    },
    {
        label: '通話開始トーン設定',
        value: 'PTTProceedTone',
        type: {
            menu: false,
            extendedMenu: true,
            key: false,
            superLock: false,
        },
    },
    {
        label: '終話トーン設定',
        value: 'PTTReleaseTone',
        type: {
            menu: false,
            extendedMenu: true,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'スキャン',
        value: 'Scan',
        type: {
            menu: true,
            extendedMenu: false,
            key: true,
            superLock: true,
        },
        function: {
            function: true,
            holdFunction: true,
            holdFunctionDefault: 'None',
        },
    },
    {
        label: 'スキャン対象',
        value: 'ScanDelete_Add',
        type: {
            menu: true,
            extendedMenu: false,
            key: true,
            superLock: true,
        },
        function: {
            function: true,
            holdFunction: true,
            holdFunctionDefault: 'None',
        },
    },
    {
        label: 'セカンド PTT グループ',
        value: 'SecondGroup',
        type: {
            menu: true,
            extendedMenu: false,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'セカンド PTT ビープ音',
        value: 'SecondGroupTone',
        type: {
            menu: true,
            extendedMenu: true,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'セカンド PTT',
        value: 'SecondPTT',
        type: {
            menu: false,
            extendedMenu: false,
            key: true,
            superLock: true,
        },
        function: {
            function: true,
            holdFunction: false,
            holdFunctionDefault: 'None',
        },
    },
    {
        label: 'サイレント・アラーム',
        value: 'SilentAlarm',
        type: {
            menu: true,
            extendedMenu: true,
            key: true,
            superLock: true,
        },
        function: {
            function: true,
            holdFunction: true,
            holdFunctionDefault: 'None',
        },
    },
    {
        label: 'SIM スロット情報',
        value: 'SIMSlotInformation',
        type: {
            menu: false,
            extendedMenu: true,
            key: false,
            superLock: false,
        },
    },
    {
        label: '音量アッテネート',
        value: 'SpeakerAttenuation',
        type: {
            menu: false,
            extendedMenu: false,
            key: true,
            superLock: true,
        },
        function: {
            function: true,
            holdFunction: true,
            holdFunctionDefault: 'None',
        },
    },
    {
        label: '履歴',
        value: 'Stack',
        type: {
            menu: true,
            extendedMenu: false,
            key: true,
            superLock: true,
        },
        function: {
            function: true,
            holdFunction: true,
            holdFunctionDefault: 'None',
        },
    },
    {
        label: '定型ステータス',
        value: 'Status',
        type: {
            menu: true,
            extendedMenu: false,
            key: true,
            superLock: true,
        },
        function: {
            function: true,
            holdFunction: true,
            holdFunctionDefault: 'Stack',
        },
    },
    {
        label: 'キー操作音設定',
        value: 'ToneVolume',
        type: {
            menu: true,
            extendedMenu: true,
            key: false,
            superLock: false,
        },
    },
    {
        label: '無線機パスワード',
        value: 'TransceiverPassword',
        type: {
            menu: true,
            extendedMenu: false,
            key: true,
            superLock: true,
        },
        function: {
            function: true,
            holdFunction: true,
            holdFunctionDefault: 'None',
        },
    },
    {
        label: 'バイブレーター',
        value: 'Vibrator',
        type: {
            menu: true,
            extendedMenu: false,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'VOX 感度',
        value: 'VOX',
        type: {
            menu: true,
            extendedMenu: true,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'VOX 遅延時間',
        value: 'VOXDelayTime',
        type: {
            menu: true,
            extendedMenu: true,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'VOX 機能',
        value: 'VOXFunction',
        type: {
            menu: true,
            extendedMenu: false,
            key: true,
            superLock: true,
        },
        function: {
            function: true,
            holdFunction: true,
            holdFunctionDefault: 'None',
        },
    },
    {
        label: 'Wi-Fi 接続',
        value: 'WiFiConnect',
        type: {
            menu: true,
            extendedMenu: false,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'Wi-Fi 機器情報',
        value: 'WiFiDeviceInformation',
        type: {
            menu: false,
            extendedMenu: true,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'Wi-Fi 設定管理',
        value: 'WiFiNetworkManagement',
        type: {
            menu: true,
            extendedMenu: false,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'Wi-Fi 無線設定',
        value: 'WiFiSettings',
        type: {
            menu: false,
            extendedMenu: true,
            key: false,
            superLock: false,
        },
    },
    {
        label: 'Wi-Fi 規格',
        value: 'WiFiStandard',
        type: {
            menu: true,
            extendedMenu: false,
            key: false,
            superLock: false,
        },
    },
    {
        label: '翻訳結果の自動読み上げ',
        value: 'RadioTranslate',
        type: {
            menu: true,
            extendedMenu: false,
            key: false,
            superLock: false,
        },
    },
    {
        label: '通話言語',
        value: 'TalkLanguage',
        type: {
            menu: true,
            extendedMenu: false,
            key: false,
            superLock: false,
        },
    },
])

// prettier-ignore
export const CATEGORY_ICON_LIST = Object.freeze([
    { value: 'Call',        label: iconCall },
    { value: 'Scan',        label: iconScan },
    { value: 'Audio_Tones', label: iconAudioTones },
    { value: 'Utility',     label: iconUtility },
    { value: 'Contacts',    label: iconContacts },
    { value: 'Setting',     label: iconSettings },
    { value: 'Message',     label: iconMessage },
    { value: 'Display',     label: iconDisplay },
    { value: 'Bluetooth',   label: iconBluetooth },
    { value: 'Battery',     label: iconBattery },
    { value: 'Category1',   label: iconCategory1 },
    { value: 'Category2',   label: iconCategory2 },
    { value: 'Category3',   label: iconCategory3 },
])


// CIDRサブネットマスク（/0〜/32）の33通り
// ※入力値(例: "255.255.255.0")が配列内に存在するかで妥当性チェックできる
export const SUBNET_MASK_LIST = Object.freeze([
    '255.0.0.0',
    '255.128.0.0',
    '255.192.0.0',
    '255.224.0.0',
    '255.240.0.0',
    '255.248.0.0',
    '255.252.0.0',
    '255.254.0.0',
    '255.255.0.0',
    '255.255.128.0',
    '255.255.192.0',
    '255.255.224.0',
    '255.255.240.0',
    '255.255.248.0',
    '255.255.252.0',
    '255.255.254.0',
    '255.255.255.0',
    '255.255.255.128',
    '255.255.255.192',
    '255.255.255.224',
    '255.255.255.240',
    '255.255.255.248',
    '255.255.255.252',
])
